import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import moment from "moment";
import { ConversionUtils } from "../../../domain/conversion-utils";

@Component({
  selector: "evrideo-time-editor",
  templateUrl: "./time-editor.component.html",
  styleUrls: ["./time-editor.component.scss"],
})
export class TimeEditorComponent implements OnInit {
  @Input()
  editMode = true;

  @Input()
  valueMs;

  @Input()
  type: "MS" | "FPS";

  @Input()
  frameRate = 25;

  @Input()
  minMs: number;

  @Input()
  fullMode = true;

  @Input()
  maxMs = Number.MAX_VALUE;

  @Output()
  valueMsChange = new EventEmitter<number>();

  @Input()
  @HostBinding("style.width")
  width = "";

  @Input()
  @HostBinding("style.height")
  @HostBinding("style.line-height")
  height = "31px";

  @Input()
  @HostBinding("style.font-size")
  fontSize = "1.3vw";

  @ViewChild("container")
  container: ElementRef;
  constructor() {}

  ngOnInit() {
    //console.log('time-editor->ngOnInit', this.valueMs);
  }

  onContentEditableClick(event: MouseEvent) {
    if (this.container.nativeElement) {
      event.stopPropagation();
      this.container.nativeElement.focus();
    }
  }

  onContentEditableKeypress(event) {
    console.log("onContentEditableKeypress", event.keyCode);
    if (event.keyCode !== 13) {
      return;
    }
    return false;
  }

  onContentEditableBlur(event) {
    console.log("time-code-editor->onContentEditableBlur->", event);
    const timeAsText = event.target.innerText;
    return this._handleValueChanged(timeAsText);
  }

  onPaste(event: ClipboardEvent) {
    console.log("time-code-editor->onPaste->", event);
    const timeAsText = event.clipboardData.getData("text");
    return this._handleValueChanged(timeAsText);
  }

  private _handleValueChanged(valAsText: string): boolean {
    const matchTime = this.testTimePattern(valAsText);
    let newValue = this.valueMs;
    this.valueMs = 0;

    try {
      if (matchTime) {
        const newHour = matchTime[1];
        const newMinutes = matchTime[2];
        const newSeconds = matchTime[3];
        const newMillisecondsOrFrames = matchTime[4];
        let newMilliseconds = parseInt(newMillisecondsOrFrames);

        let newTimeText = `${newHour.padStart(2, "0")}:${newMinutes.padStart(
          2,
          "0",
        )}:${newSeconds.padStart(2, "0")}`;
        if (this.fullMode) {
          if (this.type === "FPS") {
            const frames = parseInt(newMillisecondsOrFrames);
            newMilliseconds = ConversionUtils.getMsFromFps(
              frames,
              this.frameRate,
            );
            console.log(
              "time-code-editor->_handleValueChanged->newMilliseconds",
              newMilliseconds,
            );
            console.log(
              "time-code-editor->_handleValueChanged->newMillisecondsOrFrames",
              newMillisecondsOrFrames,
            );
            console.log(
              "time-code-editor->_handleValueChanged->frames",
              frames,
            );
          }

          newTimeText += `.${newMilliseconds.toString().padStart(3, "0")}`;
        }
        const newTimeMs = moment.duration(newTimeText).asMilliseconds();
        console.log(
          "time-code-editor->_handleValueChanged->newTimeMs",
          newTimeMs,
        );
        console.log(
          "time-code-editor->_handleValueChanged->valAsText",
          valAsText,
        );
        console.log(
          "time-code-editor->_handleValueChanged->newTimeText",
          newTimeText,
        );
        if (newTimeMs >= this.minMs) {
          if (newTimeMs <= this.maxMs) {
            newValue = newTimeMs;
          } else {
            newValue = this.maxMs;
          }
        } else {
          newValue = this.minMs;
        }
      }
    } catch (e) {}

    setTimeout(() => {
      this.valueMs = newValue;
      this.valueMsChange.emit(newValue);
    }, 0);

    //this.editMode = false;
    //console.log('time-code-editor->blur->=================================');
    return false;
  }

  formatTime(valueMs: number): string {
    //console.log('time-editor->formatTime->=========================', valueMs);
    const timeMoment = moment.duration(valueMs);
    let result = `${timeMoment.hours().toString().padStart(2, "0")}:${timeMoment
      .minutes()
      .toString()
      .padStart(2, "0")}:${timeMoment.seconds().toString().padStart(2, "0")}`;
    if (this.fullMode) {
      if (this.type === "MS") {
        result += `.${timeMoment.milliseconds().toString().padStart(3, "0")}`;
      } else {
        //convert to frames
        const frames = ConversionUtils.getFpsFromMs(
          timeMoment.milliseconds(),
          this.frameRate,
        );
        //console.log('time-code-editor->formatTime->timeMoment.milliseconds()',timeMoment.milliseconds());
        //console.log('time-code-editor->formatTime->valueMs',valueMs);
        //console.log('time-code-editor->formatTime->frames',frames);
        result += `:${frames.toString().padStart(2, "0")}`;
      }
    }

    //console.log('time-editor->formatTime->=========================', result);
    return result;
  }

  testTimePattern(time: string): RegExpMatchArray {
    let pattern =
      "(0*[0-9]|0*[1][0-9]|0*[2][0-3])\\D{1}(0*[0-9]|0*[1-5][0-9])\\D{1}(0*[0-9]|0*[1-5][0-9])";
    if (this.fullMode) {
      if (this.type === "MS") {
        pattern += "\\D{1}([0-9]{1}|[0-9]{2}|[0-9]{3})";
      } else {
        pattern += "\\D{1}([0-9]{1}|[0-9]{2}|[0-9]{2})";
      }
    }

    pattern = "^" + pattern + "$";
    const regex = new RegExp(pattern);
    console.log("regex", regex, time);
    const match = time.trim().match(regex);
    if (!match) {
      console.log("match false");
      return null;
    }
    return match;
  }
}
